    <div class="flex flex-col gap-6">
        <!-- First Row: Past Due and This Month Progress -->
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <!-- Past Due Progress -->
            <div class="flex flex-col items-center h-full">
                <div class="flex items-center gap-2">
                    <div class="text-xl font-semibold">Past Due Payments</div>
                    <fa-icon [icon]="icons.regular.faCircleInfo" class="cursor-help text-gray-500 text-lg" 
                       pTooltip="Payments that are past their due date"
                       tooltipPosition="top"></fa-icon>
                </div>
                <div class="flex flex-col items-center gap-4 py-4">
                    <div>
                        <p-knob 
                            [ngModel]="pastDueProgress().percentage"
                            [readonly]="true"
                            [size]="120"
                            [strokeWidth]="10"
                            valueColor="rgba(26, 179, 148, 0.7)"
                            valueTemplate="{value}%"
                        ></p-knob>
                    </div>
                    <div class="text-center">
                        <div class="text-2xl font-light">Paid: ${{pastDueProgress().value | number}}</div>
                        <div class="text-sm text-gray-600">Due: ${{pastDueProgress().goal | number}}</div>
                        <div class="text-sm text-gray-500 mt-1">{{pastDueProgress().paidCount}} paid of {{pastDueProgress().totalCount}} total payments overdue</div>
                    </div>
                    <p-button label="View Details" (click)="showDetailsDialog('overdue')" styleClass="btn btn-primary"></p-button>
                </div>
            </div>

            <!-- This Month Progress -->
            <div class="flex flex-col items-center h-full">
                <div class="flex items-center gap-2">
                    <div class="text-xl font-semibold">Next 30 Days</div>
                    <fa-icon [icon]="icons.regular.faCircleInfo" class="cursor-help text-gray-500 text-lg" 
                       pTooltip="Payments due in the next 30 days"
                       tooltipPosition="top"></fa-icon>
                </div>
                <div class="flex flex-col items-center gap-4 py-4">
                    <div>
                        <p-knob 
                            [ngModel]="thisMonthProgress().percentage"
                            [readonly]="true"
                            [size]="120"
                            [strokeWidth]="10"
                            valueColor="rgba(26, 179, 148, 0.7)"
                            valueTemplate="{value}%"
                        ></p-knob>
                    </div>
                    <div class="text-center">
                        <div class="text-2xl font-light">Paid: ${{thisMonthProgress().value | number}}</div>
                        <div class="text-sm text-gray-600">Due: ${{thisMonthProgress().goal | number}}</div>
                        <div class="text-sm text-gray-500 mt-1">{{thisMonthProgress().paidCount}} paid of {{thisMonthProgress().totalCount}} total payments due</div>
                    </div>
                    <p-button label="View Details" (click)="showDetailsDialog('month')" styleClass="btn btn-primary"></p-button>
                </div>
            </div>
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div class="flex flex-col items-center h-full">
                <div class="flex items-center gap-2">
                    <div class="text-xl font-semibold">{{currentYear}} Trip Payments</div>
                    <fa-icon [icon]="icons.regular.faCircleInfo" class="cursor-help text-gray-500 text-lg" 
                       pTooltip="Total payments for the current year"
                       tooltipPosition="top"></fa-icon>
                </div>
                <div class="flex flex-col items-center gap-4 py-4">
                    <div>
                        <p-knob 
                            [ngModel]="yearProgress().percentage"
                            [readonly]="true"
                            [size]="120"
                            [strokeWidth]="10"
                            valueColor="rgba(26, 179, 148, 0.7)"
                            valueTemplate="{value}%"
                        ></p-knob>
                    </div>
                    <div class="text-center">
                        <div class="text-2xl font-light">Paid: ${{yearProgress().value | number}}</div>
                        <div class="text-sm text-gray-600">Due: ${{yearProgress().goal | number}}</div>
                        <div class="text-sm text-gray-500 mt-1">{{yearProgress().paidCount}} paid of {{yearProgress().totalCount}} total payments</div>
                    </div>
                    <p-button label="View Details" (click)="showDetailsDialog('year')" styleClass="btn btn-primary"></p-button>
                </div>
            </div>
            
            <!-- Overpayments Component -->
            <app-overpayments-graph></app-overpayments-graph>
        </div>
    </div>

<!-- Details Dialog -->
<p-dialog [header]="dialogTitle" [(visible)]="detailsDialogVisible" 
    [breakpoints]="{'960px': '98vw', '1200px': '95vw'}" [style]="{'width': '98vw', 'max-width': 'none'}"
    [modal]="true" [dismissableMask]="true" appendTo="body">
    
    @if (dialogLoading()) {
        <div class="flex justify-center items-center gap-3" style="height: 200px;">
            <p-progressSpinner [style]="{'width': '50px', 'height': '50px'}" strokeWidth="4" fill="transparent" animationDuration=".5s"></p-progressSpinner>
            <span class="text-lg">Loading...</span>
        </div>
    } @else {
        <p-table #detailsTable 
            [value]="financeStats()" 
            [columns]="tableColumns"
            styleClass="p-datatable-gridlines responsive-table" 
            [tableStyle]="{'width': '100%'}"
            [exportFilename]="exportFilename"
            [globalFilterFields]="['location', 'consultant', 'groupName', 'groupLeader', 'glEmail', 'glPhone', 'quickNote', 'paymentType', 'tripId']"
            [scrollable]="true"
            scrollHeight="70vh"
            [resizableColumns]="true"
            columnResizeMode="expand">
        
        <ng-template pTemplate="caption">
            <app-table-caption [table]="detailsTable"></app-table-caption>
        </ng-template>
        
        <ng-template pTemplate="header">
            <tr>
                <app-table-headers [columns]="tableColumns"></app-table-headers>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-stat>
            <tr>
                <app-table-columns [columns]="tableColumns" [data]="stat"></app-table-columns>
            </tr>
        </ng-template>
        </p-table>
    }
</p-dialog> 